export const URLto = {
    aboutMe: '/about-me',
    things: '/things',
    thing: '/things/:projectName',
    visualArts: '/visual-arts',
}